import {type GlobalState} from 'types/store';

export const isGroupMember = (state: GlobalState, groupId: string) => {
    return state.entities.groups.myGroups.includes(groupId);
};
